import React, {memo, useEffect, useState} from "react";
import {Alert, CircularProgress, Container, Fab, FormControlLabel, Grid, Menu, MenuItem, Snackbar} from "@mui/material";
import styles from "../assets/css/user.module.scss";
import {TextField} from "../../../components/subComponents/TextField";
import {SettingApi} from "../../../utils/SettingApi";
import IOSSwitch from "../../../components/subComponents/IOSSwitch";
import Button1 from "../../../components/subComponents/Button1";
import {styled} from "@mui/material/styles";
import {useRef} from "react";
import configs from "../../../utils/config.json";
import {NeshanMap as Map} from "../../../components/subComponents/NeshanMap";
import VideoCallRoundedIcon from '@mui/icons-material/VideoCallRounded';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button4 from "../../../components/subComponents/Button4";
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded';
import AddRoundedIcon from "@mui/icons-material/AddRounded";

const NeshanMap = memo(Map);

const Input = styled('input')({
    display: 'none',
});
const fabStyle = {
    position: 'absolute',
    top: -40,
    left: -10,
};
const Settings = () => {
    const ref1 = useRef();
    const ref2 = useRef();
    const ref3 = useRef();
    const ref4 = useRef();
    const ref5 = useRef();
    const ref6 = useRef();
    const ref7 = useRef();
    const [imageLoading1, setImageLoading1] = useState(false);
    const [imageLoading2, setImageLoading2] = useState(false);
    const [imageLoading3, setImageLoading3] = useState(false);
    const [openSnackBar1, setOpenSnackBar1] = useState(false);
    const [message, setMessage] = useState('');
    const [expanded, setExpanded] = React.useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const [state, setState] = useState({
        "home": {
            "videoBanner": {
                "video": null,
                "title": "",
                "description": "",
                "hasButton1": false,
                "hasButton2": false,
                "Button1Text": "",
                "Button2Text": "",
                "button1Link":"",
                "button2Link":""
            },
            "lastNewTitle": "",
            "imageBanner": {
                "img": "",
                "title": ""
            },
            "benefit": {
                "title": "",
                "video": ""
            },
            "customersTitle": "",
            "newsTitle": ""
        },
        "aboutUs": {
            "videoBanner": {
                "video": "",
                "title": "",
                "description": "",
                "hasButton1": true,
                "hasButton2": true,
                "Button1Text": "",
                "Button2Text": "",
                "button1Link":"",
                "button2Link":""
            },
            "embeddedVideo": {
                "video": "",
                "title": "",
                "description": ""
            },
            "person": {
                "title": "",
                "slogan": ""
            },
            "manager": {
                "img": "",
                "message": "",
                "name": "",
                "position": ""
            },
            "infoBanner": {
                "img": "",
                "record": [
                    {
                        "name": "customers",
                        "amount": ""
                    },
                    {
                        "name": "customers",
                        "amount": ""
                    },
                    {
                        "name": "customers",
                        "amount": ""
                    },
                    {
                        "name": "customers",
                        "amount": ""
                    }
                ],
                "benefit": [
                    {
                        "title": "",
                        "description": ""
                    },
                    {
                        "title": "",
                        "description": ""
                    },
                    {
                        "title": "",
                        "description": ""
                    }
                ]
            }
        },
        "footer": {
            "index": 0,
            "places": [],
            "mail": ""
        }
    });
    const handleClickSnackBar1 = (text) => {
        setOpenSnackBar1(true);
        setMessage(text);
    };
    const handleCloseSnackBar1 = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenSnackBar1(false);
    };
    const get = async () => {
        await SettingApi.getSetting((result) => {
            setState(result.data);
            document.getElementById("img1").setAttribute("src", `${configs.server.Storage}/${result.data.home.videoBanner.video}`);
            document.getElementById("img2-1").setAttribute("src", `${configs.server.Storage}/${result.data.home.imageBanner.img}`);
            document.getElementById("img-ben1").setAttribute("src", `${configs.server.Storage}/${result.data.home.benefit.video}`);
            document.getElementById("img12").setAttribute("src", `${configs.server.Storage}/${result.data.aboutUs.videoBanner.video}`);
            document.getElementById("img133").setAttribute("src", `${configs.server.Storage}/${result.data.aboutUs.embeddedVideo.video}`);
            document.getElementById("img4-51").setAttribute("src", `${configs.server.Storage}/${result.data.aboutUs.manager.img}`);

            document.getElementById("img4-61").setAttribute("src", `${configs.server.Storage}/${result.data.aboutUs.infoBanner.img}`);

            console.log(result.data.home.imageBanner);
        }, (error) => {
        })
    }
    useEffect(() => {
        (async () => {
            await get();
        })();
    }, [])
    useEffect(() => {
        console.log(state.footer);
    }, [state]);

    const setDefault = (index) => {
        setState({...state, footer: {...state.footer, index: index}});
    }

    const deletePlace = (index) => {
        setState({
            ...state,
            footer: {
                ...state.footer,
                places: [...state.footer.places.slice(0, index), ...state.footer.places.slice(index + 1)]
            }
        });
    }

    const addNewPlace = () => {
        setState({
            ...state, footer: {
                ...state.footer, places: [...state.footer.places, {
                    "address": "",
                    "lat": "35.6997362112193",
                    "lng": "51.337618205943",
                    "phone": ""
                }]
            }
        });

    }

    const editPlace = (index, place) => {
        setState({
            ...state,
            footer: {
                ...state.footer,
                places: [...state.footer.places.slice(0, index), place, ...state.footer.places.slice((index + 1))]
            }
        });
    }

    return <>

        <Container maxWidth={"lg"}>
            <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon/>}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                >
                    <Typography sx={{width: '33%', flexShrink: 0}}>
                        تنظیمات صفحه اصلی
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container>
                        <Grid item xs={12} container>
                            <Grid item xs={6}>
                                <div className={styles.inputContainer} style={{paddingTop: 45}}>
                                    <TextField label="عنوان بنر" variant="outlined"
                                               value={state.home.videoBanner.title}
                                               onChange={e => {
                                                   setState({
                                                       ...state,
                                                       home: {
                                                           ...state.home,
                                                           videoBanner: {
                                                               ...state.home.videoBanner,
                                                               title: e.target.value
                                                           }
                                                       }
                                                   })
                                               }}
                                               fullWidth
                                    />
                                </div>
                                <div className={styles.inputContainer}>
                                    <TextField label="شرح" variant="outlined"
                                               value={state.home.videoBanner.description}
                                               onChange={e => {
                                                   setState({
                                                       ...state,
                                                       home: {
                                                           ...state.home,
                                                           videoBanner: {
                                                               ...state.home.videoBanner,
                                                               description: e.target.value
                                                           }
                                                       }
                                                   })
                                               }}
                                               fullWidth
                                    />
                                </div>
                                <div className={styles.inputContainer}>

                                    <Grid container spacing={2}>
                                        <Grid item xs={4}>
                                            <TextField label="متن کلید شماره 1" variant="outlined"
                                                       value={state.home.videoBanner.Button1Text}
                                                       disabled={!state.home.videoBanner.hasButton1}

                                                       onChange={e => {
                                                           setState({
                                                               ...state,
                                                               home: {
                                                                   ...state.home,
                                                                   videoBanner: {
                                                                       ...state.home.videoBanner,
                                                                       Button1Text: e.target.value
                                                                   }
                                                               }
                                                           })
                                                       }}
                                                       fullWidth
                                            />
                                        </Grid>
                                        <Grid item xs={4}>
                                            <TextField label="لینک کلید شماره 1" variant="outlined"
                                                       value={state.home.videoBanner.Button1Link}
                                                       disabled={!state.home.videoBanner.hasButton1}
                                                       style={{textAlign:"center",direction:"ltr"}}

                                                       onChange={e => {
                                                           setState({
                                                               ...state,
                                                               home: {
                                                                   ...state.home,
                                                                   videoBanner: {
                                                                       ...state.home.videoBanner,
                                                                       Button1Link: e.target.value
                                                                   }
                                                               }
                                                           })
                                                       }}
                                                       fullWidth
                                            />
                                        </Grid>
                                        <Grid item xs={4}>
                                            <FormControlLabel
                                                className={styles.switch}
                                                control={<IOSSwitch sx={{m: 1}}
                                                                    checked={state.home.videoBanner.hasButton1}
                                                                    onChange={e => {
                                                                        if (e.target.checked)
                                                                            setState({
                                                                                ...state,
                                                                                home: {
                                                                                    ...state.home,
                                                                                    videoBanner: {
                                                                                        ...state.home.videoBanner,
                                                                                        hasButton1: true
                                                                                    }
                                                                                }
                                                                            })
                                                                        else setState({
                                                                            ...state,
                                                                            home: {
                                                                                ...state.home,
                                                                                videoBanner: {
                                                                                    ...state.home.videoBanner,
                                                                                    hasButton1: false
                                                                                }
                                                                            }
                                                                        })
                                                                    }}
                                                />}
                                                label="وضعیت کلید 1"
                                            />
                                        </Grid>
                                    </Grid>
                                </div>
                                <div className={styles.inputContainer}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={4}>
                                            <TextField label="متن کلید شماره 2" variant="outlined"
                                                       value={state.home.videoBanner.Button2Text}
                                                       disabled={!state.home.videoBanner.hasButton2}
                                                       onChange={e => {
                                                           setState({
                                                               ...state,
                                                               home: {
                                                                   ...state.home,
                                                                   videoBanner: {
                                                                       ...state.home.videoBanner,
                                                                       Button2Text: e.target.value
                                                                   }
                                                               }
                                                           })
                                                       }}
                                                       fullWidth
                                            />
                                        </Grid>
                                        <Grid item xs={4}>
                                            <TextField label="لینک کلید شماره 2" variant="outlined"
                                                       value={state.home.videoBanner.Button2Link}
                                                       disabled={!state.home.videoBanner.hasButton2}
                                                       style={{textAlign:"center",direction:"ltr"}}

                                                       onChange={e => {
                                                           setState({
                                                               ...state,
                                                               home: {
                                                                   ...state.home,
                                                                   videoBanner: {
                                                                       ...state.home.videoBanner,
                                                                       Button2Link: e.target.value
                                                                   }
                                                               }
                                                           })
                                                       }}
                                                       fullWidth
                                            />
                                        </Grid>
                                        <Grid item xs={4}>
                                            <FormControlLabel
                                                className={styles.switch}
                                                control={<IOSSwitch sx={{m: 1}}
                                                                    checked={state.home.videoBanner.hasButton2}
                                                                    onChange={e => {
                                                                        if (e.target.checked)
                                                                            setState({
                                                                                ...state,
                                                                                home: {
                                                                                    ...state.home,
                                                                                    videoBanner: {
                                                                                        ...state.home.videoBanner,
                                                                                        hasButton2: true
                                                                                    }
                                                                                }
                                                                            })
                                                                        else setState({
                                                                            ...state,
                                                                            home: {
                                                                                ...state.home,
                                                                                videoBanner: {
                                                                                    ...state.home.videoBanner,
                                                                                    hasButton2: false
                                                                                }
                                                                            }
                                                                        })
                                                                    }}
                                                />}
                                                label="وضعیت کلید 2"
                                            />
                                        </Grid>
                                    </Grid>

                                </div>
                                <div className={styles.inputContainer}>
                                    <Button1 onClick={e => {
                                        let fd = new FormData();
                                        fd.append("payload", JSON.stringify({
                                            home: {
                                                videoBanner: state.home.videoBanner
                                            }
                                        }));

                                        (async () => {
                                            await SettingApi.updateSetting(fd, (result) => {
                                                handleClickSnackBar1('بروز رسانی انجام شد!');
                                            }, (error) => {
                                            })
                                        })();
                                    }}>
                                        ثبت
                                    </Button1>
                                </div>
                            </Grid>
                            <Grid item xs={6}>
                                <div style={{display: "flex", flexDirection: "column"}}>
                                    <label
                                           style={{
                                               display: "flex",
                                               flexDirection: "column",
                                               justifyContent: "center",
                                               width: "calc(100% - 30px)",
                                               margin: 15
                                           }}>
                                        <Input accept="video/mp4,video/x-m4v,video/*" multiple type="file" ref={ref1}
                                               id={"img"}
                                               onChange={e => {
                                                   setImageLoading1(true);
                                                   let files = e.target.files; // FileList object

                                                   // use the 1st file from the list
                                                   let f = files[0];

                                                   let reader = new FileReader();
                                                   // Closure to capture the file information.
                                                   reader.onload = (function (theFile) {
                                                       return function (e) {
                                                           document.getElementById("img1").setAttribute("src", this.result);
                                                           document.getElementById("img1").play();

                                                           setImageLoading1(false);
                                                           console.log("image loaded!!")
                                                       };
                                                   })(f);

                                                   // Read in the image file as a data URL.
                                                   reader.readAsDataURL(f);
                                               }}/>
                                        <div style={{
                                            width: "100%",
                                            borderRadius: 15,
                                            margin: 15,
                                            overflow: "hidden",
                                            position: "relative",
                                            height: 250
                                        }}>
                                            <video id={"img1"}
                                                   style={{
                                                       width: "100%",
                                                       position: "absolute",
                                                       top: 0,
                                                       height: "100%",
                                                       zIndex: 1
                                                   }}
                                                   src={'https://ndb-soft.com/wp-content/uploads/2020/06/placeholder.png'}
                                                   controls muted/>
                                            <div style={{
                                                top: 130,
                                                width: "100%",
                                                display: "flex",
                                                flexDirection: "row",
                                                justifyContent: "center",
                                                position: "absolute",
                                                zIndex: 2
                                            }}>
                                                {imageLoading1 && <CircularProgress/>}
                                            </div>
                                        </div>
                                        <div>
                                            <VideoCallRoundedIcon/>

                                        </div>
                                    </label>

                                    <Button1
                                        style={{margin: 15, width: "calc(100% - 30px)"}}
                                        onClick={e => {
                                            let fd = new FormData();
                                            fd.append("payload", JSON.stringify({
                                                home: {
                                                    videoBanner: state.home.videoBanner
                                                }
                                            }));
                                            if (ref1.current.files.length)
                                                fd.append("video", ref1.current.files[0]);
                                            (async () => {
                                                await SettingApi.updateSetting(fd, (result) => {
                                                    handleClickSnackBar1('بروز رسانی انجام شد!');

                                                }, (error) => {
                                                })
                                            })();
                                        }}>
                                        ثبت
                                    </Button1>
                                </div>

                            </Grid>

                            <Grid item xs={6}>
                                <div className={styles.inputContainer} style={{paddingTop: 45}}>
                                    <TextField label="عنوان بنر" variant="outlined"
                                               value={state.home.lastNewTitle}
                                               onChange={e => {
                                                   setState({
                                                       ...state,
                                                       home: {
                                                           ...state.home,
                                                           lastNewTitle: e.target.value
                                                       }
                                                   })
                                               }}
                                               fullWidth
                                    />
                                </div>
                                <div className={styles.inputContainer} style={{}}>
                                    <Button1 onClick={e => {
                                        let fd = new FormData();
                                        fd.append("payload", JSON.stringify({
                                            home: {
                                                lastNewTitle: state.home.lastNewTitle
                                            }
                                        }));

                                        (async () => {
                                            await SettingApi.updateSetting(fd, (result) => {
                                                handleClickSnackBar1('بروز رسانی انجام شد!');

                                            }, (error) => {
                                            })
                                        })();
                                    }}>
                                        ثبت
                                    </Button1>
                                </div>
                                <div style={{display: "flex", flexDirection: "column"}}>
                                    <label htmlFor="img3"
                                           style={{
                                               display: "flex",
                                               flexDirection: "column",
                                               justifyContent: "center",
                                               width: "calc(100% - 30px)",
                                               margin: 15
                                           }}>
                                        <Input accept="image/*" multiple type="file" ref={ref2} id={"img3"}
                                               onChange={e => {
                                                   setImageLoading2(true);
                                                   let files = e.target.files; // FileList object

                                                   // use the 1st file from the list
                                                   let f = files[0];

                                                   let reader = new FileReader();
                                                   // Closure to capture the file information.
                                                   reader.onload = (function (theFile) {
                                                       return function (e) {
                                                           setImageLoading2(false);
                                                           document.getElementById("img2-1").setAttribute("src", this.result);
                                                       };
                                                   })(f);

                                                   // Read in the image file as a data URL.
                                                   reader.readAsDataURL(f);
                                               }}/>
                                        <div style={{
                                            width: "100%",
                                            borderRadius: 15,
                                            overflow: "hidden",
                                            position: "relative",
                                            height: 250
                                        }}>
                                            <img id={"img2-1"}
                                                 style={{
                                                     width: "100%",
                                                     position: "absolute",
                                                     top: 0,
                                                     height: "100%",
                                                     zIndex: 1
                                                 }}
                                                 src={'https://ndb-soft.com/wp-content/uploads/2020/06/placeholder.png'}
                                                 alt={""}/>
                                            <div style={{
                                                top: 130,
                                                width: "100%",
                                                display: "flex",
                                                flexDirection: "row",
                                                justifyContent: "center",
                                                position: "absolute",
                                                zIndex: 2
                                            }}>
                                                {imageLoading2 && <CircularProgress/>}
                                            </div>
                                        </div>

                                    </label>

                                    <Button1
                                        style={{margin: 15, width: "calc(100% - 30px)"}}
                                        onClick={e => {
                                            let fd = new FormData();
                                            fd.append("payload", JSON.stringify({
                                                home: {
                                                    imageBanner: state.home.imageBanner
                                                }
                                            }));
                                            if (ref2.current.files.length)
                                                fd.append("photo", ref2.current.files[0]);
                                            (async () => {
                                                await SettingApi.updateSetting(fd, (result) => {
                                                    handleClickSnackBar1('بروز رسانی انجام شد!');

                                                }, (error) => {
                                                })
                                            })();
                                        }}>
                                        ثبت
                                    </Button1>
                                </div>
                                <div className={styles.inputContainer}>
                                    <TextField label="شرح" variant="outlined"
                                               value={state.home.imageBanner.title}
                                               onChange={e => {
                                                   setState({
                                                       ...state,
                                                       home: {
                                                           ...state.home,
                                                           imageBanner: {
                                                               ...state.home.imageBanner,
                                                               title: e.target.value
                                                           }
                                                       }
                                                   })
                                               }}
                                               fullWidth
                                    />
                                    <Button1 style={{marginTop: 15}} onClick={e => {
                                        let fd = new FormData();
                                        fd.append("payload", JSON.stringify({
                                            home: {
                                                imageBanner: state.home.imageBanner
                                            }
                                        }));
                                        (async () => {
                                            await SettingApi.updateSetting(fd, (result) => {
                                                handleClickSnackBar1('بروز رسانی انجام شد!');

                                            }, (error) => {
                                            })
                                        })();
                                    }}>
                                        ثبت
                                    </Button1>
                                </div>
                            </Grid>
                            <Grid item xs={6}>
                                <div className={styles.inputContainer} style={{paddingTop: 45}}>
                                    <TextField label="عنوان بنر" variant="outlined"
                                               value={state.home.benefit.title}
                                               onChange={e => {
                                                   setState({
                                                       ...state,
                                                       home: {
                                                           ...state.home,
                                                           benefit: {...state.home.benefit, title: e.target.value}
                                                       }
                                                   })
                                               }}
                                               fullWidth
                                    />
                                </div>
                                <div className={styles.inputContainer}>
                                    <Button1
                                        style={{margin: 15, width: "calc(100% - 30px)"}}
                                        onClick={e => {
                                            let fd = new FormData();
                                            fd.append("payload", JSON.stringify({
                                                home: {
                                                    benefit: {
                                                        title: state.home.benefit.title
                                                    }
                                                }
                                            }));
                                            (async () => {
                                                await SettingApi.updateSetting(fd, (result) => {
                                                    handleClickSnackBar1('بروز رسانی انجام شد!');

                                                }, (error) => {
                                                })
                                            })();
                                        }}>
                                        ثبت
                                    </Button1>
                                </div>
                                <div style={{display: "flex", flexDirection: "column"}}>
                                    <label htmlFor="img-ben"
                                           style={{
                                               display: "flex",
                                               flexDirection: "column",
                                               justifyContent: "center",
                                               width: "calc(100% - 30px)",
                                               margin: 15
                                           }}>
                                        <Input accept="video/mp4,video/x-m4v,video/*" multiple type="file" ref={ref3}
                                               id={"img-ben"}
                                               onChange={e => {
                                                   setImageLoading3(true);
                                                   let files = e.target.files; // FileList object

                                                   // use the 1st file from the list
                                                   let f = files[0];

                                                   let reader = new FileReader();
                                                   // Closure to capture the file information.
                                                   reader.onload = (function (theFile) {
                                                       return function (e) {
                                                           document.getElementById("img-ben1").setAttribute("src", this.result);
                                                           document.getElementById("img-ben1").play();

                                                           setImageLoading3(false);
                                                           console.log("image loaded!!")
                                                       };
                                                   })(f);

                                                   // Read in the image file as a data URL.
                                                   reader.readAsDataURL(f);
                                               }}/>
                                        <div style={{
                                            width: "100%",
                                            borderRadius: 15,
                                            margin: 15,
                                            overflow: "hidden",
                                            position: "relative",
                                            height: 250
                                        }}>
                                            <video id={"img-ben1"}
                                                   style={{
                                                       width: "100%",
                                                       position: "absolute",
                                                       top: 0,
                                                       height: "100%",
                                                       zIndex: 1
                                                   }}
                                                   src={'https://ndb-soft.com/wp-content/uploads/2020/06/placeholder.png'}
                                                   controls muted/>
                                            <div style={{
                                                top: 130,
                                                width: "100%",
                                                display: "flex",
                                                flexDirection: "row",
                                                justifyContent: "center",
                                                position: "absolute",
                                                zIndex: 2
                                            }}>
                                                {imageLoading3 && <CircularProgress/>}
                                            </div>
                                        </div>
                                        <div>
                                            <VideoCallRoundedIcon/>

                                        </div>
                                    </label>

                                    <Button1
                                        style={{margin: 15, width: "calc(100% - 30px)"}}
                                        onClick={e => {
                                            let fd = new FormData();
                                            fd.append("payload", JSON.stringify({
                                                home: {
                                                    benefit: state.home.benefit
                                                }
                                            }));
                                            if (ref3.current.files.length)
                                                fd.append("video", ref3.current.files[0]);
                                            (async () => {
                                                await SettingApi.updateSetting(fd, (result) => {
                                                    handleClickSnackBar1('بروز رسانی انجام شد!');

                                                }, (error) => {
                                                })
                                            })();
                                        }}>
                                        ثبت
                                    </Button1>
                                </div>

                            </Grid>
                            <Grid item xs={6}>
                                <div className={styles.inputContainer} style={{paddingTop: 45}}>
                                    <TextField label="عنوان بنر" variant="outlined"
                                               value={state.home.customersTitle}
                                               onChange={e => {
                                                   setState({
                                                       ...state,
                                                       home: {
                                                           ...state.home,
                                                           customersTitle: e.target.value
                                                       }
                                                   })
                                               }}
                                               fullWidth
                                    />
                                </div>
                                <div className={styles.inputContainer}>
                                    <Button1
                                        style={{margin: 15, width: "calc(100% - 30px)"}}
                                        onClick={e => {
                                            let fd = new FormData();
                                            fd.append("payload", JSON.stringify({
                                                home: {
                                                    customersTitle: state.home.customersTitle
                                                }
                                            }));
                                            (async () => {
                                                await SettingApi.updateSetting(fd, (result) => {
                                                    handleClickSnackBar1('بروز رسانی انجام شد!');

                                                }, (error) => {
                                                })
                                            })();
                                        }}>
                                        ثبت
                                    </Button1>
                                </div>

                            </Grid>
                            <Grid item xs={6}>
                                <div className={styles.inputContainer} style={{paddingTop: 45}}>
                                    <TextField label="عنوان بنر" variant="outlined"
                                               value={state.home.newsTitle}
                                               onChange={e => {
                                                   setState({
                                                       ...state,
                                                       home: {
                                                           ...state.home,
                                                           newsTitle: e.target.value
                                                       }
                                                   })
                                               }}
                                               fullWidth
                                    />
                                </div>
                                <div className={styles.inputContainer}>
                                    <Button1
                                        style={{margin: 15, width: "calc(100% - 30px)"}}
                                        onClick={e => {
                                            let fd = new FormData();
                                            fd.append("payload", JSON.stringify({
                                                home: {
                                                    newsTitle: state.home.newsTitle
                                                }
                                            }));
                                            (async () => {
                                                await SettingApi.updateSetting(fd, (result) => {
                                                    handleClickSnackBar1('بروز رسانی انجام شد!');

                                                }, (error) => {
                                                })
                                            })();
                                        }}>
                                        ثبت
                                    </Button1>
                                </div>

                            </Grid>
                        </Grid>
                    </Grid>

                </AccordionDetails>
            </Accordion>
            <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon/>}
                    aria-controls="panel2bh-content"
                    id="panel2bh-header"
                >
                    <Typography sx={{width: '33%', flexShrink: 0}}>تنظیمات صفحه درباره ما</Typography>

                </AccordionSummary>
                <AccordionDetails>
                    <Grid container>
                        <Grid xs={6} item>
                            <div className={styles.inputContainer} style={{paddingTop: 45}}>
                                <TextField label="عنوان بنر" variant="outlined"
                                           value={state.aboutUs.videoBanner.title}
                                           onChange={e => {
                                               setState({
                                                   ...state,
                                                   aboutUs: {
                                                       ...state.aboutUs,
                                                       videoBanner: {
                                                           ...state.aboutUs.videoBanner,
                                                           title: e.target.value
                                                       }
                                                   }
                                               })
                                           }}
                                           fullWidth
                                />
                            </div>
                            <div className={styles.inputContainer}>
                                <TextField label="شرح" variant="outlined"
                                           value={state.aboutUs.videoBanner.description}
                                           onChange={e => {
                                               setState({
                                                   ...state,
                                                   aboutUs: {
                                                       ...state.aboutUs,
                                                       videoBanner: {
                                                           ...state.aboutUs.videoBanner,
                                                           description: e.target.value
                                                       }
                                                   }
                                               })
                                           }}
                                           fullWidth
                                />
                            </div>
                            <div className={styles.inputContainer}>

                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <TextField label="متن کلید شماره 1" variant="outlined"
                                                   value={state.aboutUs.videoBanner.Button1Text}
                                                   disabled={!state.aboutUs.videoBanner.hasButton1}

                                                   onChange={e => {
                                                       setState({
                                                           ...state,
                                                           aboutUs: {
                                                               ...state.aboutUs,
                                                               videoBanner: {
                                                                   ...state.aboutUs.videoBanner,
                                                                   Button1Text: e.target.value
                                                               }
                                                           }
                                                       })
                                                   }}
                                                   fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <TextField label="لینک کلید شماره 1" variant="outlined"
                                                   value={state.aboutUs.videoBanner.Button1Link}
                                                   disabled={!state.aboutUs.videoBanner.hasButton1}
                                                   style={{textAlign:"center",direction:"ltr"}}

                                                   onChange={e => {
                                                       setState({
                                                           ...state,
                                                           aboutUs: {
                                                               ...state.aboutUs,
                                                               videoBanner: {
                                                                   ...state.aboutUs.videoBanner,
                                                                   Button1Link: e.target.value
                                                               }
                                                           }
                                                       })
                                                   }}
                                                   fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <FormControlLabel
                                            className={styles.switch}
                                            control={<IOSSwitch sx={{m: 1}}
                                                                checked={state.aboutUs.videoBanner.hasButton1}
                                                                onChange={e => {
                                                                    if (e.target.checked)
                                                                        setState({
                                                                            ...state,
                                                                            aboutUs: {
                                                                                ...state.aboutUs,
                                                                                videoBanner: {
                                                                                    ...state.aboutUs.videoBanner,
                                                                                    hasButton1: true
                                                                                }
                                                                            }
                                                                        })
                                                                    else setState({
                                                                        ...state,
                                                                        aboutUs: {
                                                                            ...state.aboutUs,
                                                                            videoBanner: {
                                                                                ...state.aboutUs.videoBanner,
                                                                                hasButton1: false
                                                                            }
                                                                        }
                                                                    })
                                                                }}
                                            />}
                                            label="وضعیت کلید 1"
                                        />
                                    </Grid>
                                </Grid>
                            </div>
                            <div className={styles.inputContainer}>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <TextField label="متن کلید شماره 2" variant="outlined"
                                                   value={state.aboutUs.videoBanner.Button2Text}
                                                   disabled={!state.aboutUs.videoBanner.hasButton2}
                                                   onChange={e => {
                                                       setState({
                                                           ...state,
                                                           aboutUs: {
                                                               ...state.aboutUs,
                                                               videoBanner: {
                                                                   ...state.aboutUs.videoBanner,
                                                                   Button2Text: e.target.value
                                                               }
                                                           }
                                                       })
                                                   }}
                                                   fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <TextField label="لینک کلید شماره 2" variant="outlined"
                                                   value={state.aboutUs.videoBanner.Button2Link}
                                                   disabled={!state.aboutUs.videoBanner.hasButton2}
                                                   style={{textAlign:"center",direction:"ltr"}}
                                                   onChange={e => {
                                                       setState({
                                                           ...state,
                                                           aboutUs: {
                                                               ...state.aboutUs,
                                                               videoBanner: {
                                                                   ...state.aboutUs.videoBanner,
                                                                   Button2Link: e.target.value
                                                               }
                                                           }
                                                       })
                                                   }}
                                                   fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <FormControlLabel
                                            className={styles.switch}
                                            control={<IOSSwitch sx={{m: 1}}
                                                                checked={state.aboutUs.videoBanner.hasButton2}
                                                                onChange={e => {
                                                                    if (e.target.checked)
                                                                        setState({
                                                                            ...state,
                                                                            aboutUs: {
                                                                                ...state.aboutUs,
                                                                                videoBanner: {
                                                                                    ...state.aboutUs.videoBanner,
                                                                                    hasButton2: true
                                                                                }
                                                                            }
                                                                        })
                                                                    else setState({
                                                                        ...state,
                                                                        aboutUs: {
                                                                            ...state.aboutUs,
                                                                            videoBanner: {
                                                                                ...state.aboutUs.videoBanner,
                                                                                hasButton2: false
                                                                            }
                                                                        }
                                                                    })
                                                                }}
                                            />}
                                            label="وضعیت کلید 2"
                                        />
                                    </Grid>
                                </Grid>

                            </div>
                            <div className={styles.inputContainer}>
                                <Button1 onClick={e => {
                                    let fd = new FormData();
                                    fd.append("payload", JSON.stringify({
                                        aboutUs: {
                                            videoBanner: state.aboutUs.videoBanner
                                        }
                                    }));

                                    (async () => {
                                        await SettingApi.updateSetting(fd, (result) => {
                                            handleClickSnackBar1('بروز رسانی انجام شد!');
                                        }, (error) => {
                                        })
                                    })();
                                }}>
                                    ثبت
                                </Button1>
                            </div>
                        </Grid>
                        <Grid xs={6} item>
                            <div style={{display: "flex", flexDirection: "column"}}>
                                <label htmlFor="img122"
                                       style={{
                                           display: "flex",
                                           flexDirection: "column",
                                           justifyContent: "center",
                                           width: "calc(100% - 30px)",
                                           margin: 15
                                       }}>
                                    <Input accept="video/mp4,video/x-m4v,video/*" type="file" ref={ref4}
                                           id={"img122"}
                                           onChange={e => {
                                               setImageLoading1(true);
                                               let files = e.target.files; // FileList object

                                               // use the 1st file from the list
                                               let f = files[0];

                                               let reader = new FileReader();
                                               // Closure to capture the file information.
                                               reader.onload = (function (theFile) {
                                                   return function (e) {
                                                       document.getElementById("img12").setAttribute("src", this.result);
                                                       document.getElementById("img12").play();

                                                       setImageLoading1(false);
                                                       console.log("image loaded!!")
                                                   };
                                               })(f);

                                               // Read in the image file as a data URL.
                                               reader.readAsDataURL(f);
                                           }}/>
                                    <div style={{
                                        width: "100%",
                                        borderRadius: 15,
                                        margin: 15,
                                        overflow: "hidden",
                                        position: "relative",
                                        height: 250
                                    }}>
                                        <video id={"img12"}
                                               style={{
                                                   width: "100%",
                                                   position: "absolute",
                                                   top: 0,
                                                   height: "100%",
                                                   zIndex: 1
                                               }}
                                               controls muted/>
                                        <div style={{
                                            top: 130,
                                            width: "100%",
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "center",
                                            position: "absolute",
                                            zIndex: 2
                                        }}>
                                            {imageLoading1 && <CircularProgress/>}
                                        </div>
                                    </div>
                                    <div>
                                        <VideoCallRoundedIcon/>

                                    </div>
                                </label>

                                <Button1
                                    style={{margin: 15, width: "calc(100% - 30px)"}}
                                    onClick={e => {
                                        let fd = new FormData();
                                        fd.append("payload", JSON.stringify({
                                            aboutUs: {
                                                videoBanner: state.aboutUs.videoBanner
                                            }
                                        }));
                                        if (ref4.current.files.length)
                                            fd.append("video", ref4.current.files[0]);
                                        (async () => {
                                            await SettingApi.updateSetting(fd, (result) => {
                                                handleClickSnackBar1('بروز رسانی انجام شد!');

                                            }, (error) => {
                                            })
                                        })();
                                    }}>
                                    ثبت
                                </Button1>
                            </div>

                        </Grid>
                        <Grid xs={6} item>
                            <div className={styles.inputContainer} style={{paddingTop: 45}}>
                                <TextField label="عنوان بنر" variant="outlined"
                                           value={state.aboutUs.embeddedVideo.title}
                                           onChange={e => {
                                               setState({
                                                   ...state,
                                                   aboutUs: {
                                                       ...state.aboutUs,
                                                       embeddedVideo: {
                                                           ...state.aboutUs.embeddedVideo,
                                                           title: e.target.value
                                                       }
                                                   }
                                               })
                                           }}
                                           fullWidth
                                />
                            </div>
                            <div className={styles.inputContainer}>
                                <TextField label="شرح" variant="outlined"
                                           value={state.aboutUs.embeddedVideo.description}
                                           onChange={e => {
                                               setState({
                                                   ...state,
                                                   aboutUs: {
                                                       ...state.aboutUs,
                                                       embeddedVideo: {
                                                           ...state.aboutUs.embeddedVideo,
                                                           description: e.target.value
                                                       }
                                                   }
                                               })
                                           }}
                                           fullWidth
                                           multiline
                                           rows={4}
                                />
                            </div>
                            <div className={styles.inputContainer}>
                                <Button1 onClick={e => {
                                    let fd = new FormData();
                                    fd.append("payload", JSON.stringify({
                                        aboutUs: {
                                            embeddedVideo: state.aboutUs.embeddedVideo
                                        }
                                    }));

                                    (async () => {
                                        await SettingApi.updateSetting(fd, (result) => {
                                            handleClickSnackBar1('بروز رسانی انجام شد!');
                                        }, (error) => {
                                        })
                                    })();
                                }}>
                                    ثبت
                                </Button1>
                            </div>
                        </Grid>
                        <Grid xs={6} item>
                            <div style={{display: "flex", flexDirection: "column"}}>
                                <label htmlFor="img1222"
                                       style={{
                                           display: "flex",
                                           flexDirection: "column",
                                           justifyContent: "center",
                                           width: "calc(100% - 30px)",
                                           margin: 15
                                       }}>
                                    <Input accept="video/mp4,video/x-m4v,video/*" type="file" ref={ref5}
                                           id={"img1222"}
                                           onChange={e => {
                                               setImageLoading1(true);
                                               let files = e.target.files; // FileList object

                                               // use the 1st file from the list
                                               let f = files[0];

                                               let reader = new FileReader();
                                               // Closure to capture the file information.
                                               reader.onload = (function (theFile) {
                                                   return function (e) {
                                                       document.getElementById("img133").setAttribute("src", this.result);
                                                       document.getElementById("img133").play();

                                                       setImageLoading1(false);
                                                       console.log("image loaded!!")
                                                   };
                                               })(f);

                                               // Read in the image file as a data URL.
                                               reader.readAsDataURL(f);
                                           }}/>
                                    <div style={{
                                        width: "100%",
                                        borderRadius: 15,
                                        margin: 15,
                                        overflow: "hidden",
                                        position: "relative",
                                        height: 250
                                    }}>
                                        <video id={"img133"}
                                               style={{
                                                   width: "100%",
                                                   position: "absolute",
                                                   top: 0,
                                                   height: "100%",
                                                   zIndex: 1
                                               }}
                                               controls muted/>
                                        <div style={{
                                            top: 130,
                                            width: "100%",
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "center",
                                            position: "absolute",
                                            zIndex: 2
                                        }}>
                                            {imageLoading1 && <CircularProgress/>}
                                        </div>
                                    </div>
                                    <div>
                                        <VideoCallRoundedIcon/>

                                    </div>
                                </label>

                                <Button1
                                    style={{margin: 15, width: "calc(100% - 30px)"}}
                                    onClick={e => {
                                        let fd = new FormData();
                                        fd.append("payload", JSON.stringify({
                                            aboutUs: {
                                                embeddedVideo: state.aboutUs.embeddedVideo
                                            }
                                        }));
                                        if (ref5.current.files.length)
                                            fd.append("video", ref5.current.files[0]);
                                        (async () => {
                                            await SettingApi.updateSetting(fd, (result) => {
                                                handleClickSnackBar1('بروز رسانی انجام شد!');

                                            }, (error) => {
                                            })
                                        })();
                                    }}>
                                    ثبت
                                </Button1>
                            </div>

                        </Grid>
                        <Grid xs={6} item>
                            <div className={styles.inputContainer} style={{paddingTop: 45}}>
                                <TextField label="عنوان بنر" variant="outlined"
                                           value={state.aboutUs.manager.name}
                                           onChange={e => {
                                               setState({
                                                   ...state,
                                                   aboutUs: {
                                                       ...state.aboutUs,
                                                       manager: {
                                                           ...state.aboutUs.manager,
                                                           name: e.target.value
                                                       }
                                                   }
                                               })
                                           }}
                                           fullWidth
                                />
                            </div>
                            <div className={styles.inputContainer}>
                                <TextField label="عنوان بنر" variant="outlined"
                                           value={state.aboutUs.manager.position}
                                           onChange={e => {
                                               setState({
                                                   ...state,
                                                   aboutUs: {
                                                       ...state.aboutUs,
                                                       manager: {
                                                           ...state.aboutUs.manager,
                                                           position: e.target.value
                                                       }
                                                   }
                                               })
                                           }}
                                           fullWidth
                                />
                            </div>
                            <div className={styles.inputContainer}>
                                <TextField label="شرح" variant="outlined"
                                           value={state.aboutUs.manager.message}
                                           onChange={e => {
                                               setState({
                                                   ...state,
                                                   aboutUs: {
                                                       ...state.aboutUs,
                                                       manager: {
                                                           ...state.aboutUs.manager,
                                                           message: e.target.value
                                                       }
                                                   }
                                               })
                                           }}
                                           fullWidth
                                           multiline
                                           rows={4}
                                />
                            </div>
                            <div className={styles.inputContainer}>
                                <Button1 onClick={e => {
                                    let fd = new FormData();
                                    fd.append("payload", JSON.stringify({
                                        aboutUs: {
                                            manager: state.aboutUs.manager
                                        }
                                    }));

                                    (async () => {
                                        await SettingApi.updateSetting(fd, (result) => {
                                            handleClickSnackBar1('بروز رسانی انجام شد!');
                                        }, (error) => {
                                        })
                                    })();
                                }}>
                                    ثبت
                                </Button1>
                            </div>
                        </Grid>
                        <Grid xs={6} item>
                            <div style={{display: "flex", flexDirection: "column"}}>
                                <label htmlFor="img45"
                                       style={{
                                           display: "flex",
                                           flexDirection: "column",
                                           justifyContent: "center",
                                           width: "calc(100% - 30px)",
                                           margin: 15
                                       }}>
                                    <Input accept="image/*" multiple type="file" ref={ref6} id={"img45"}
                                           onChange={e => {
                                               setImageLoading2(true);
                                               let files = e.target.files; // FileList object

                                               // use the 1st file from the list
                                               let f = files[0];

                                               let reader = new FileReader();
                                               // Closure to capture the file information.
                                               reader.onload = (function (theFile) {
                                                   return function (e) {
                                                       setImageLoading2(false);
                                                       document.getElementById("img4-51").setAttribute("src", this.result);
                                                   };
                                               })(f);

                                               // Read in the image file as a data URL.
                                               reader.readAsDataURL(f);
                                           }}/>
                                    <div style={{
                                        width: "100%",
                                        borderRadius: 15,
                                        overflow: "hidden",
                                        position: "relative",
                                        height: 250
                                    }}>
                                        <img id={"img4-51"}
                                             style={{
                                                 width: "100%",
                                                 position: "absolute",
                                                 top: 0,
                                                 height: "100%",
                                                 zIndex: 1
                                             }}
                                             src={'https://ndb-soft.com/wp-content/uploads/2020/06/placeholder.png'}
                                             alt={""}/>
                                        <div style={{
                                            top: 130,
                                            width: "100%",
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "center",
                                            position: "absolute",
                                            zIndex: 2
                                        }}>
                                            {imageLoading2 && <CircularProgress/>}
                                        </div>
                                    </div>
                                </label>

                                <Button1
                                    style={{margin: 15, width: "calc(100% - 30px)"}}
                                    onClick={e => {
                                        let fd = new FormData();
                                        fd.append("payload", JSON.stringify({
                                            aboutUs: {
                                                manager: state.aboutUs.manager
                                            }
                                        }));
                                        if (ref6.current.files.length)
                                            fd.append("photo", ref6.current.files[0]);
                                        (async () => {
                                            await SettingApi.updateSetting(fd, (result) => {
                                                handleClickSnackBar1('بروز رسانی انجام شد!');

                                            }, (error) => {
                                            })
                                        })();
                                    }}>
                                    ثبت
                                </Button1>
                            </div>


                        </Grid>
                        <Grid xs={6} item>
                            <div className={styles.inputContainer} style={{paddingTop: 45}}>
                                <TextField label="عنوان بنر" variant="outlined"
                                           value={state.aboutUs.person.title}
                                           onChange={e => {
                                               setState({
                                                   ...state,
                                                   aboutUs: {
                                                       ...state.aboutUs,
                                                       person: {
                                                           ...state.aboutUs.person,
                                                           title: e.target.value
                                                       }
                                                   }
                                               })
                                           }}
                                           fullWidth
                                />
                            </div>
                            <div className={styles.inputContainer}>
                                <TextField label="عنوان بنر" variant="outlined"
                                           value={state.aboutUs.person.slogan}
                                           onChange={e => {
                                               setState({
                                                   ...state,
                                                   aboutUs: {
                                                       ...state.aboutUs,
                                                       person: {
                                                           ...state.aboutUs.person,
                                                           slogan: e.target.value
                                                       }
                                                   }
                                               })
                                           }}
                                           fullWidth
                                />
                            </div>
                            <div className={styles.inputContainer}>
                                <Button1 onClick={e => {
                                    let fd = new FormData();
                                    fd.append("payload", JSON.stringify({
                                        aboutUs: {
                                            person: state.aboutUs.person
                                        }
                                    }));

                                    (async () => {
                                        await SettingApi.updateSetting(fd, (result) => {
                                            handleClickSnackBar1('بروز رسانی انجام شد!');
                                        }, (error) => {
                                        })
                                    })();
                                }}>
                                    ثبت
                                </Button1>
                            </div>
                        </Grid>
                        <Grid xs={6} item>
                            <div className={styles.inputContainer} style={{paddingTop: 45}}>
                                <TextField label="عنوان بنر" variant="outlined"
                                           value={state.aboutUs.infoBanner.record[0].name}
                                           onChange={e => {
                                               setState({
                                                   ...state,
                                                   aboutUs: {
                                                       ...state.aboutUs,
                                                       infoBanner: {
                                                           ...state.aboutUs.infoBanner,
                                                           record: [{
                                                               ...state.aboutUs.infoBanner.record[0],
                                                               name: e.target.value
                                                           }, ...state.aboutUs.infoBanner.record.slice(1)]
                                                       }
                                                   }
                                               })
                                           }}
                                           fullWidth
                                />
                            </div>
                            <div className={styles.inputContainer}>
                                <TextField label="عنوان بنر" variant="outlined"
                                           value={state.aboutUs.infoBanner.record[0].amount}
                                           onChange={e => {
                                               setState({
                                                   ...state,
                                                   aboutUs: {
                                                       ...state.aboutUs,
                                                       infoBanner: {
                                                           ...state.aboutUs.infoBanner,
                                                           record: [{
                                                               ...state.aboutUs.infoBanner.record[0],
                                                               amount: e.target.value
                                                           }, ...state.aboutUs.infoBanner.record.slice(1)]
                                                       }
                                                   }
                                               })
                                           }}
                                           fullWidth
                                />
                            </div>


                            <div className={styles.inputContainer} style={{paddingTop: 45}}>
                                <TextField label="عنوان بنر" variant="outlined"
                                           value={state.aboutUs.infoBanner.record[1].name}
                                           onChange={e => {
                                               setState({
                                                   ...state,
                                                   aboutUs: {
                                                       ...state.aboutUs,
                                                       infoBanner: {
                                                           ...state.aboutUs.infoBanner,
                                                           record: [state.aboutUs.infoBanner.record[0], {
                                                               ...state.aboutUs.infoBanner.record[1],
                                                               name: e.target.value
                                                           }, ...state.aboutUs.infoBanner.record.slice(2)]
                                                       }
                                                   }
                                               })
                                           }}
                                           fullWidth
                                />
                            </div>
                            <div className={styles.inputContainer}>
                                <TextField label="عنوان بنر" variant="outlined"
                                           value={state.aboutUs.infoBanner.record[1].amount}
                                           onChange={e => {
                                               setState({
                                                   ...state,
                                                   aboutUs: {
                                                       ...state.aboutUs,
                                                       infoBanner: {
                                                           ...state.aboutUs.infoBanner,
                                                           record: [state.aboutUs.infoBanner.record[0], {
                                                               ...state.aboutUs.infoBanner.record[1],
                                                               amount: e.target.value
                                                           }, ...state.aboutUs.infoBanner.record.slice(2)]
                                                       }
                                                   }
                                               })
                                           }}
                                           fullWidth
                                />
                            </div>


                            <div className={styles.inputContainer} style={{paddingTop: 45}}>
                                <TextField label="عنوان بنر" variant="outlined"
                                           value={state.aboutUs.infoBanner.record[2].name}
                                           onChange={e => {
                                               setState({
                                                   ...state,
                                                   aboutUs: {
                                                       ...state.aboutUs,
                                                       infoBanner: {
                                                           ...state.aboutUs.infoBanner,
                                                           record: [state.aboutUs.infoBanner.record[0], state.aboutUs.infoBanner.record[1], {
                                                               ...state.aboutUs.infoBanner.record[2],
                                                               name: e.target.value
                                                           }, state.aboutUs.infoBanner.record[3]]
                                                       }
                                                   }
                                               })
                                           }}
                                           fullWidth
                                />
                            </div>
                            <div className={styles.inputContainer}>
                                <TextField label="عنوان بنر" variant="outlined"
                                           value={state.aboutUs.infoBanner.record[2].amount}
                                           onChange={e => {
                                               setState({
                                                   ...state,
                                                   aboutUs: {
                                                       ...state.aboutUs,
                                                       infoBanner: {
                                                           ...state.aboutUs.infoBanner,
                                                           record: [state.aboutUs.infoBanner.record[0], state.aboutUs.infoBanner.record[1], {
                                                               ...state.aboutUs.infoBanner.record[2],
                                                               amount: e.target.value
                                                           }, state.aboutUs.infoBanner.record[3]]
                                                       }
                                                   }
                                               })
                                           }}
                                           fullWidth
                                />
                            </div>


                            <div className={styles.inputContainer} style={{paddingTop: 45}}>
                                <TextField label="عنوان بنر" variant="outlined"
                                           value={state.aboutUs.infoBanner.record[3].name}
                                           onChange={e => {
                                               setState({
                                                   ...state,
                                                   aboutUs: {
                                                       ...state.aboutUs,
                                                       infoBanner: {
                                                           ...state.aboutUs.infoBanner,
                                                           record: [state.aboutUs.infoBanner.record[0], state.aboutUs.infoBanner.record[1], state.aboutUs.infoBanner.record[2], {
                                                               ...state.aboutUs.infoBanner.record[3],
                                                               name: e.target.value
                                                           }]
                                                       }
                                                   }
                                               })
                                           }}
                                           fullWidth
                                />
                            </div>
                            <div className={styles.inputContainer}>
                                <TextField label="عنوان بنر" variant="outlined"
                                           value={state.aboutUs.infoBanner.record[3].amount}
                                           onChange={e => {
                                               setState({
                                                   ...state,
                                                   aboutUs: {
                                                       ...state.aboutUs,
                                                       infoBanner: {
                                                           ...state.aboutUs.infoBanner,
                                                           record: [state.aboutUs.infoBanner.record[0], state.aboutUs.infoBanner.record[1], state.aboutUs.infoBanner.record[2], {
                                                               ...state.aboutUs.infoBanner.record[3],
                                                               amount: e.target.value
                                                           }]
                                                       }
                                                   }
                                               })
                                           }}
                                           fullWidth
                                />
                            </div>


                            <div className={styles.inputContainer}>
                                <Button1 onClick={e => {
                                    let fd = new FormData();
                                    fd.append("payload", JSON.stringify({
                                        aboutUs: {
                                            infoBanner: state.aboutUs.infoBanner
                                        }
                                    }));

                                    (async () => {
                                        await SettingApi.updateSetting(fd, (result) => {
                                            handleClickSnackBar1('بروز رسانی انجام شد!');
                                        }, (error) => {
                                        })
                                    })();
                                }}>
                                    ثبت
                                </Button1>
                            </div>
                        </Grid>
                        <Grid xs={6} item>
                            <div className={styles.inputContainer} style={{paddingTop: 45}}>
                                <TextField label="عنوان بنر" variant="outlined"
                                           value={state.aboutUs.infoBanner.benefit[0].title}
                                           onChange={e => {
                                               setState({
                                                   ...state,
                                                   aboutUs: {
                                                       ...state.aboutUs,
                                                       infoBanner: {
                                                           ...state.aboutUs.infoBanner,
                                                           benefit: [{
                                                               ...state.aboutUs.infoBanner.benefit[0],
                                                               title: e.target.value
                                                           }, ...state.aboutUs.infoBanner.benefit.slice(1)]
                                                       }
                                                   }
                                               })
                                           }}
                                           fullWidth
                                />
                            </div>
                            <div className={styles.inputContainer}>
                                <TextField label="عنوان بنر" variant="outlined"
                                           value={state.aboutUs.infoBanner.benefit[0].description}
                                           onChange={e => {
                                               setState({
                                                   ...state,
                                                   aboutUs: {
                                                       ...state.aboutUs,
                                                       infoBanner: {
                                                           ...state.aboutUs.infoBanner,
                                                           benefit: [{
                                                               ...state.aboutUs.infoBanner.benefit[0],
                                                               description: e.target.value
                                                           }, ...state.aboutUs.infoBanner.benefit.slice(1)]
                                                       }
                                                   }
                                               })
                                           }}
                                           fullWidth
                                           multiline
                                           rows={4}
                                />
                            </div>


                            <div className={styles.inputContainer} style={{paddingTop: 45}}>
                                <TextField label="عنوان بنر" variant="outlined"
                                           value={state.aboutUs.infoBanner.benefit[1].title}
                                           onChange={e => {
                                               setState({
                                                   ...state,
                                                   aboutUs: {
                                                       ...state.aboutUs,
                                                       infoBanner: {
                                                           ...state.aboutUs.infoBanner,
                                                           benefit: [state.aboutUs.infoBanner.benefit[0], {
                                                               ...state.aboutUs.infoBanner.benefit[1],
                                                               title: e.target.value
                                                           }, ...state.aboutUs.infoBanner.benefit.slice(2)]
                                                       }
                                                   }
                                               })
                                           }}
                                           fullWidth
                                />
                            </div>
                            <div className={styles.inputContainer}>
                                <TextField label="عنوان بنر" variant="outlined"
                                           value={state.aboutUs.infoBanner.benefit[1].description}
                                           onChange={e => {
                                               setState({
                                                   ...state,
                                                   aboutUs: {
                                                       ...state.aboutUs,
                                                       infoBanner: {
                                                           ...state.aboutUs.infoBanner,
                                                           benefit: [state.aboutUs.infoBanner.benefit[0], {
                                                               ...state.aboutUs.infoBanner.benefit[1],
                                                               description: e.target.value
                                                           }, ...state.aboutUs.infoBanner.benefit.slice(2)]
                                                       }
                                                   }
                                               })
                                           }}
                                           fullWidth
                                           multiline
                                           rows={4}
                                />
                            </div>


                            <div className={styles.inputContainer} style={{paddingTop: 45}}>
                                <TextField label="عنوان بنر" variant="outlined"
                                           value={state.aboutUs.infoBanner.benefit[2].title}
                                           onChange={e => {
                                               setState({
                                                   ...state,
                                                   aboutUs: {
                                                       ...state.aboutUs,
                                                       infoBanner: {
                                                           ...state.aboutUs.infoBanner,
                                                           benefit: [state.aboutUs.infoBanner.benefit[0], state.aboutUs.infoBanner.benefit[1], {
                                                               ...state.aboutUs.infoBanner.benefit[2],
                                                               title: e.target.value
                                                           }]
                                                       }
                                                   }
                                               })
                                           }}
                                           fullWidth
                                />
                            </div>
                            <div className={styles.inputContainer}>
                                <TextField label="عنوان بنر" variant="outlined"
                                           value={state.aboutUs.infoBanner.benefit[2].description}
                                           onChange={e => {
                                               setState({
                                                   ...state,
                                                   aboutUs: {
                                                       ...state.aboutUs,
                                                       infoBanner: {
                                                           ...state.aboutUs.infoBanner,
                                                           benefit: [state.aboutUs.infoBanner.benefit[0], state.aboutUs.infoBanner.benefit[1], {
                                                               ...state.aboutUs.infoBanner.benefit[2],
                                                               description: e.target.value
                                                           }]
                                                       }
                                                   }
                                               })
                                           }}
                                           fullWidth
                                           multiline
                                           rows={4}
                                />
                            </div>


                            <div className={styles.inputContainer}>
                                <Button1 onClick={e => {
                                    let fd = new FormData();
                                    fd.append("payload", JSON.stringify({
                                        aboutUs: {
                                            infoBanner: state.aboutUs.infoBanner
                                        }
                                    }));

                                    (async () => {
                                        await SettingApi.updateSetting(fd, (result) => {
                                            handleClickSnackBar1('بروز رسانی انجام شد!');
                                        }, (error) => {
                                        })
                                    })();
                                }}>
                                    ثبت
                                </Button1>
                            </div>
                        </Grid>


                        <Grid xs={6} item>
                            <div style={{display: "flex", flexDirection: "column"}}>
                                <label htmlFor="img65"
                                       style={{
                                           display: "flex",
                                           flexDirection: "column",
                                           justifyContent: "center",
                                           width: "calc(100% - 30px)",
                                           margin: 15
                                       }}>
                                    <Input accept="image/*" multiple type="file" ref={ref7} id={"img65"}
                                           onChange={e => {
                                               setImageLoading2(true);
                                               let files = e.target.files; // FileList object

                                               // use the 1st file from the list
                                               let f = files[0];

                                               let reader = new FileReader();
                                               // Closure to capture the file information.
                                               reader.onload = (function (theFile) {
                                                   return function (e) {
                                                       setImageLoading2(false);
                                                       document.getElementById("img4-61").setAttribute("src", this.result);
                                                   };
                                               })(f);

                                               // Read in the image file as a data URL.
                                               reader.readAsDataURL(f);
                                           }}/>
                                    <div style={{
                                        width: "100%",
                                        borderRadius: 15,
                                        overflow: "hidden",
                                        position: "relative",
                                        height: 250
                                    }}>
                                        <img id={"img4-61"}
                                             style={{
                                                 width: "100%",
                                                 position: "absolute",
                                                 top: 0,
                                                 height: "100%",
                                                 zIndex: 1
                                             }}
                                             src={'https://ndb-soft.com/wp-content/uploads/2020/06/placeholder.png'}
                                             alt={""}/>
                                        <div style={{
                                            top: 130,
                                            width: "100%",
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "center",
                                            position: "absolute",
                                            zIndex: 2
                                        }}>
                                            {imageLoading2 && <CircularProgress/>}
                                        </div>
                                    </div>
                                </label>

                                <Button1
                                    style={{margin: 15, width: "calc(100% - 30px)"}}
                                    onClick={e => {
                                        let fd = new FormData();
                                        fd.append("payload", JSON.stringify({
                                            aboutUs: {
                                                infoBanner: state.aboutUs.infoBanner
                                            }
                                        }));
                                        if (ref7.current.files.length)
                                            fd.append("photo", ref7.current.files[0]);
                                        (async () => {
                                            await SettingApi.updateSetting(fd, (result) => {
                                                handleClickSnackBar1('بروز رسانی انجام شد!');

                                            }, (error) => {
                                            })
                                        })();
                                    }}>
                                    ثبت
                                </Button1>
                            </div>


                        </Grid>

                    </Grid>


                </AccordionDetails>
            </Accordion>
            <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon/>}
                    aria-controls="panel2bh-content"
                    id="panel2bh-header"
                >
                    <Typography sx={{width: '33%', flexShrink: 0}}>تنظیمات پانویس</Typography>

                </AccordionSummary>
                <AccordionDetails>
                    <div style={{position: "relative"}}>
                        {state.footer.places.map((item, index) => <FooterItem {...item} index={index}
                                                                              setDefault={setDefault} key={index}
                                                                              deletePlace={deletePlace}
                                                                              editPlace={editPlace}/>)}
                        <div className={styles.inputContainer}>
                            <TextField label="پست الکترونیکی" variant="outlined"
                                       value={state.footer.mail}
                                       onChange={e => {
                                           setState({
                                               ...state,
                                               footer: {
                                                   ...state.footer,
                                                   mail: e.target.value

                                               }
                                           })
                                       }}
                                       fullWidth
                            />
                        </div>
                        <div className={styles.inputContainer}>
                            <Button1 onClick={e => {
                                let fd = new FormData();
                                fd.append("payload", JSON.stringify({
                                    footer: state.footer

                                }))
                                ;

                                (async () => {
                                    await SettingApi.updateSetting(fd, (result) => {
                                        handleClickSnackBar1('بروز رسانی انجام شد!');
                                    }, (error) => {
                                    })
                                })();
                            }}>
                                ثبت
                            </Button1>
                        </div>
                        <Fab sx={fabStyle} color="primary" onClick={() => {
                            addNewPlace();
                        }}>
                            <AddRoundedIcon/>
                        </Fab>


                    </div>


                </AccordionDetails>
            </Accordion>
        </Container>
        <Snackbar open={openSnackBar1} autoHideDuration={2000}
                  onClose={handleCloseSnackBar1}
                  className={styles.snackBar}
                  anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
        >
            <Alert
                severity="success"
                className={styles.txt}
            >
                {message}
            </Alert>
        </Snackbar>
    </>;
};
export default Settings;


const FooterItem = (props) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return <div style={{position: "relative", margin: 40}}>
        <Button4
            id="demo-positioned-button"
            aria-controls={open ? 'demo-positioned-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
            style={{position: "absolute", top: -35, left: -35}}
        >
            <MoreVertRoundedIcon/>
        </Button4>
        <Menu
            id="demo-positioned-menu"
            aria-labelledby="demo-positioned-button"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
        >
            <MenuItem onClick={e => {
                handleClose();
                props.deletePlace(props.index);
            }}>حذف</MenuItem>
            <MenuItem onClick={e => {
                handleClose();
                props.setDefault(props.index);
            }}>انتخاب به عنوان پیشفرض</MenuItem>
        </Menu>
        <Grid container>
            <Grid item xs={6}>
                <div className={styles.inputContainer} style={{paddingTop: 0}}>
                    <TextField label="شماره تماس" variant="outlined"
                               value={props.phone}
                               className={styles.ltrTextField}
                               onChange={e => {
                                   props.editPlace(props.index, {
                                       address: props.address,
                                       lat: props.lat,
                                       lng: props.lng,
                                       phone: e.target.value
                                   })
                               }}
                               fullWidth
                    />
                </div>
                <div className={styles.inputContainer}>
                    <TextField label="lat" variant="outlined"
                               value={props.lat}
                               className={styles.ltrTextField}

                               onChange={e => {
                                   props.editPlace(props.index, {
                                       address: props.address,
                                       lat: e.target.value,
                                       lng: props.lng,
                                       phone: props.phone
                                   })
                               }}
                               fullWidth
                    />
                </div>
                <div className={styles.inputContainer}>
                    <TextField label="lng" variant="outlined"
                               value={props.lng}
                               className={styles.ltrTextField}

                               onChange={e => {
                                   props.editPlace(props.index, {
                                       address: props.address,
                                       lat: props.lat,
                                       lng: e.target.value,
                                       phone: props.phone
                                   })
                               }}
                               fullWidth
                    />
                </div>
                <div className={styles.inputContainer}>
                    <TextField label="آدرس" variant="outlined"
                               value={props.address}
                               multiline
                               rows={4}
                               onChange={e => {
                                   props.editPlace(props.index, {
                                       address: e.target.value,
                                       lat: props.lat,
                                       lng: props.lng,
                                       phone: props.phone
                                   })
                               }}
                               fullWidth
                    />
                </div>

            </Grid>
            <Grid item xs={6}>
                <NeshanMap
                    style={{
                        width: "100%", height: "350px", margin: 0, padding: 0, background: "#eee",
                    }}
                    options={{
                        key: 'web.Qcm8Zwe5LAZbpH8cv9wwYJDBRY0Kv6J1fkaJihgZ',
                        center: [props.lat, props.lng],
                        zoom: 16,
                        maptype: 'standard-night',
                        zoomControl: true,
                        search: true,
                        serviceKey: "service.An7lQ4gLCirxxggUdU2U7Cxhv1YCgsOc9BNsiHWj",

                    }}

                    onInit={(L, myMap) => {
                        let marker = L.marker([props.lat, props.lng], {draggable: 'true'})
                            .addTo(myMap);
                        // setR1(L);
                        // setR2(myMap);
                        myMap.on('click', function (e) {
                            marker.setLatLng(e.latlng);
                            props.editPlace(props.index, {
                                address: props.address,
                                lat: e.latlng.lat,
                                lng: e.latlng.lng,
                                phone: props.phone
                            })


                        });
                        marker.on('dragend', function (event) {
                            let marker = event.target;

                            props.editPlace(props.index, {
                                address: props.address,
                                lat: marker.getLatLng().lat,
                                lng: marker.getLatLng().lng,
                                phone: props.phone
                            })

                        });


                        myMap.on('zoom', function (e) {
                            // setZoom(myMap.getZoom());

                        });
                        myMap.on('click', async function (e) {

                        });

                        myMap.on('move', function (e) {
                            // setZoom(myMap.getZoom());
                        });

                        myMap.on('locationfound', function (ev) {
                            // myMap.flyTo(ev.latlng, 17)

                        });
                    }}

                />
            </Grid>

        </Grid>
    </div>

}